// Autogenerated during build time. Do not modify.
export const RICOS_VERSION = '10.164.4';
